export default "__VITE_ASSET__BYKxWVLK__"